import styled from 'styled-components'

export const NewCardFlex = styled.div`
  display: flex;
  width: 180px;
  justify-content: space-between;
  align-items: center;

  .card_detail_img {
    width: 48px;
    height: 40px;
  }

  .new_card_text {
    margin-right: 20px;
  }

  /* .svg_wrapper {
    margin-right: 30px;
  } */
`

export const SelectPaymentWrapper = styled.div`
  .card_img {
    height: 70px !important;
    border-radius: 50% !important;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .choose {
    color: ${({ theme }) => theme.colors.CollaboBlue};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    padding-right: 20px;
  }
  img {
    width: 8px;
  }
`

export const PaymentSwitch = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .svg_wrapper {
    width: 48px;
    height: 40px;
    background: #cdd2fd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .payment_text_wrapper {
    display: flex;
    align-items: center;
  }

  .payment_text {
    color: ${({ theme }) => theme.colors.secondPrimary};
    font-weight: 400;
    line-height: 20px;
  }
  .payment_svg {
    margin-left: 18px;
  }
  .switch_btn {
    color: ${({ theme }) => theme.colors.successGreen};
    cursor: pointer;
  }
`
